export default "__VITE_ASSET__s3wrhLV9__"